import React, { useState, useEffect, useRef } from 'react';
import '../ccss/TrabajadorModal.css';
import { FaAddressCard, FaPen, FaTimes, FaCheck, FaFileContract, FaFileInvoiceDollar, FaFileInvoice, FaFileImport, FaUpload, FaHardHat } from 'react-icons/fa';
import { formatRut, cleanRut, formatRutDV, validarCampos, validarArchivo } from '../Validations/TrabajadoresValidation';
import Axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import config from '../Componentes/config';
import { registrarLog } from '../Componentes/logService';
import { useCookies } from 'react-cookie';
import $ from "jquery";

function TrabajadorModal({ isOpen, trabajador, onClose }) {
    const [cookies] = useCookies(['selectedCard']);
    const [tab, setTab] = useState('general');
    const [editMode, setEditMode] = useState(false);
    const [id, setID] = useState(0);
    const [empresa, setEmpresa] = useState("");
    const [nombres, setNombres] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [nacionalidad, setNacionalidad] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState("");
    const [estadoCivil, setEstadoCivil] = useState("");
    const [afp, setAfp] = useState("");
    const [rut, setRut] = useState("");
    const [prevision, setPrevision] = useState("");
    const [domicilio, setDomicilio] = useState("");
    const [comuna, setComuna] = useState("");
    const [cargo, setCargo] = useState("");
    const [tipoContrato, setTipoContrato] = useState("");
    const [vigenciaDesde, setVigenciaDesde] = useState("");
    const [vigenciaHasta, setVigenciaHasta] = useState("");
    const [TipoArchivo, setTipoArchivo] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
    const [dragOver, setDragOver] = useState(false);
    const inputRef = useRef(null);

    function CargaDatosIniciales() {
        setNombres(trabajador.Nombres);
        setApellidos(trabajador.Apellidos);
        setRut(trabajador.Rut);
        setNacionalidad(trabajador.Nacionalidad);
        setFechaNacimiento(trabajador.FechaNacimiento);
        setEstadoCivil(trabajador.EstadoCivil);
        setAfp(trabajador.AFP);
        setPrevision(trabajador.Prevision);
        setDomicilio(trabajador.Domicilio);
        setComuna(trabajador.Comuna);
        setCargo(trabajador.Cargo);
        setTipoContrato(trabajador.TipoContrato);
        setVigenciaDesde(trabajador.VigenciaDesde);
        setVigenciaHasta(trabajador.VigenciaHasta);
        setEmpresa(trabajador.Empresa);
        setID(trabajador.ID_Trabajador);
    }

    const UpdateTrabajador = async () => {
        try {
            if (!validarCampos({
                empresa, nombres, apellidos, nacionalidad, fechaNacimiento, estadoCivil,
                afp, rut, prevision, domicilio, comuna, cargo,
                tipoContrato, vigenciaDesde, vigenciaHasta
            })) {
                Swal.fire({
                    title: '¡Advertencia!',
                    text: 'Debes completar toda la informacion antes de actulizar!.',
                    icon: 'warning',
                    didOpen: () => {
                        const container = document.querySelector('.swal2-container');
                        const popup = document.querySelector('.swal2-popup');
                        if (container) container.style.zIndex = '9999';
                        if (popup) popup.style.zIndex = '10000';
                    }
                });
                return; // Si faltan campos, no procede con el registro
            }
            const rutSinFormato = cleanRut(rut);
            await Axios.put(`${config.API_URL}/ActualizaTrabajador`, {
                id,
                empresa,
                nombres,
                apellidos,
                nacionalidad,
                fechaNacimiento,
                estadoCivil,
                afp,
                rut: rutSinFormato,
                prevision,
                domicilio,
                comuna,
                cargo,
                tipoContrato,
                vigenciaDesde,
                vigenciaHasta
            });
            Swal.fire({
                title: '¡Éxito!',
                text: 'El trabajador ha sido actualizado exitosamente.',
                icon: 'success',
                didOpen: () => {
                    const container = document.querySelector('.swal2-container');
                    const popup = document.querySelector('.swal2-popup');
                    if (container) container.style.zIndex = '9999';
                    if (popup) popup.style.zIndex = '10000';
                }
            });
            console.log('Registrando log...');
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Trabajadores',
                Detalle: `Update de trabajador: ${id}`,
                Estado: 'Éxito',
            });
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Trabajadores',
                Detalle: `Update de trabajador: ${nombres} ${apellidos} - error ${error.message}`,
                Estado: 'Fallo',
            });
            Swal.fire({
                title: 'Algo pasó!',
                text: 'El trabajador no se pudo actualizar.',
                icon: 'success',
                didOpen: () => {
                    const container = document.querySelector('.swal2-container');
                    const popup = document.querySelector('.swal2-popup');
                    if (container) container.style.zIndex = '9999';
                    if (popup) popup.style.zIndex = '10000';
                }
            });
        }
    };

    const renderTablaArchivos = () => (
        <div className="table-responsive">
            {archivosDB.length > 0 ? (
                <table className="table table-bordered" id="dataTableFiles" width="100%" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Tipo Archivo</th>
                            <th>Fecha Carga</th>
                            <th>Usuario Carga</th>
                            <th>Archivo</th>
                            <th>Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {archivosDB.map((archivo, index) => (
                            <tr key={index}>
                                <td>{archivo.ID_Registro}</td>
                                <td>{archivo.Tipo_Archivo}</td>
                                <td>{moment(archivo.Fecha_Carga).format('DD/MM/YYYY')}</td>
                                <td>{archivo.Usuario_Carga}</td>
                                <td>
                                    <a
                                        href={`${config.API_URL}/uploads/${empresa}-${rut}/${encodeURIComponent(archivo.Nombre_Archivo)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {archivo.Nombre_Archivo}
                                    </a>
                                </td>
                                <td>
                                    <button
                                        type="button"
                                        onClick={() => deleteFile(archivo)}
                                        className="btn btn-danger btn-sm"
                                        title="Solicitar eliminación"
                                    >
                                        <i className="fas fa-trash"></i> Eliminar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>No hay archivos en la base de datos.</p>
            )}
        </div>
    );

    const [archivosDB, setArchivosDB] = useState([]);
    const handleTabChange = (newTab) => {
        setTab(newTab);
        fetchFiles(newTab); // Aquí le pasas directamente "contratos" como tipoArchivo
    };

    const fetchFiles = async (tipoArchivo) => {
        if (rut) {
            try {
                const response = await Axios.get(`${config.API_URL}/CargaArchivos`, {
                    params: {
                        Rut: rut,
                        Empresa: empresa,
                        TipoArchivo: tipoArchivo,
                    },
                });

                const archivos = Array.isArray(response.data.archivosDB) ? response.data.archivosDB : [];

                if ($.fn.DataTable.isDataTable("#filesTable")) {
                    $('#filesTable').DataTable().destroy();
                }

                setArchivosDB(archivos);
            } catch (error) {
                console.error("Error fetching files", error);
                if ($.fn.DataTable.isDataTable("#filesTable")) {
                    $('#filesTable').DataTable().destroy();
                }
                setArchivosDB([]);
            }
        }
    };

    const deleteFile = async (archivo) => {
        const result = await Swal.fire({
            title: '¿Solicitar eliminación de archivo?',
            html: `
                <p>Se enviará una solicitud al administrador para eliminar este archivo:</p>
                <ul style="text-align: left; margin-top: 10px;">
                    <li><strong>ID:</strong> ${archivo.ID_Registro}</li>
                    <li><strong>Tipo:</strong> ${archivo.Tipo_Archivo}</li>
                    <li><strong>Nombre:</strong> ${archivo.Nombre_Archivo}</li>
                </ul>
                <textarea id="motivoEliminacion" class="swal2-input" placeholder="Motivo de la eliminación (opcional)" style="height: 80px; width: 90%;"></textarea>
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, solicitar eliminación',
            cancelButtonText: 'Cancelar',
            didOpen: () => {
                const container = document.querySelector('.swal2-container');
                const popup = document.querySelector('.swal2-popup');
                if (container) container.style.zIndex = '9999';
                if (popup) popup.style.zIndex = '10000';
            },
            preConfirm: () => {
                return document.getElementById('motivoEliminacion').value;
            }
        });

        if (result.isConfirmed) {
            const motivo = result.value;
            const datos = {
                ID_Registro: archivo.ID_Registro,
                ID_Empresa: empresa,
                Usuario_Crea: cookies.usuario,
                Observacion: motivo
            };

            try {
                const response = await Axios.post(`${config.API_URL}/solicitarEliminacionArchivo`, datos, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Trabajadores',
                    Detalle: `Solicitud de eliminación de archivo ID: ${archivo.ID_Registro} - Trabajador RUT: ${rut}`,
                    Estado: 'Éxito',
                });

                Swal.fire({
                    icon: 'success',
                    title: '¡Solicitud enviada!',
                    text: response.data.message || 'La solicitud de eliminación ha sido enviada al administrador.',
                    confirmButtonColor: '#3085d6',
                    didOpen: () => {
                        const container = document.querySelector('.swal2-container');
                        const popup = document.querySelector('.swal2-popup');
                        if (container) container.style.zIndex = '9999';
                        if (popup) popup.style.zIndex = '10000';
                    }
                });

                // Recargar archivos con el tab actual
                fetchFiles(tab);
            } catch (error) {
                await registrarLog({
                    Usuario: cookies.usuario,
                    Modulo: 'Trabajadores',
                    Detalle: `Error al solicitar eliminación de archivo ID: ${archivo.ID_Registro} - Error: ${error.message || error}`,
                    Estado: 'Fallo',
                });

                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data || 'Hubo un error al enviar la solicitud de eliminación.',
                    confirmButtonColor: '#d33',
                    didOpen: () => {
                        const container = document.querySelector('.swal2-container');
                        const popup = document.querySelector('.swal2-popup');
                        if (container) container.style.zIndex = '9999';
                        if (popup) popup.style.zIndex = '10000';
                    }
                });
            }
        }
    };

    const onFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const onFileUpload = async () => {
        const mensajeError = validarArchivo(selectedFile, TipoArchivo);

        if (mensajeError) {
            Swal.fire({
                title: '¡Advertencia!',
                text: mensajeError,
                icon: 'warning',
                didOpen: () => {
                    const container = document.querySelector('.swal2-container');
                    const popup = document.querySelector('.swal2-popup');
                    if (container) container.style.zIndex = '9999';
                    if (popup) popup.style.zIndex = '10000';
                }
            });
            return; // Detiene la función si falla la validación
        }
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("Rut", rut); // Suponiendo que 'rut' está disponible en el estado
        formData.append("TipoArchivo", TipoArchivo); // Suponiendo que 'rut' está disponible en el estado
        formData.append("FechaCarga", moment().format('YYYY-MM-DD HH:mm:ss')); // Agrega 'apellidos' si está disponible
        formData.append("UsuarioCarga", cookies.usuario); // Suponiendo que 'mail' contiene la fecha de carga
        formData.append("Empresa", empresa); // Suponiendo que 'mail' contiene la fecha de carga
        console.log("FormData empresa:", empresa);
        try {
            const response = Axios.post(`${config.API_URL}/SubeArchivo/${empresa}/${rut}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            Swal.fire({
                title: '¡Éxito!',
                text: 'El archivo se subio exitosamente.',
                icon: 'success',
                didOpen: () => {
                    const container = document.querySelector('.swal2-container');
                    const popup = document.querySelector('.swal2-popup');
                    if (container) container.style.zIndex = '9999';
                    if (popup) popup.style.zIndex = '10000';
                }
            });
            fetchFiles();
            setArchivoSeleccionado(null);
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Trabajadores',
                Detalle: `Agrega archivo de trabajador: ${id}`,
                Estado: 'Exito',
            });
        } catch (error) {
            await registrarLog({
                Usuario: cookies.usuario,
                Modulo: 'Trabajadores',
                Detalle: `Delete archivo de trabajador: ${id}`,
                Estado: 'Error',
            });
            Swal.fire({
                title: '¡Algo pasó!',
                text: 'El archivo no pudo ser subido.',
                icon: 'error',
                didOpen: () => {
                    const container = document.querySelector('.swal2-container');
                    const popup = document.querySelector('.swal2-popup');
                    if (container) container.style.zIndex = '9999';
                    if (popup) popup.style.zIndex = '10000';
                }
            });
        }
    }


    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => {
        setDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const file = e.dataTransfer.files[0];
        if (file) {
            setArchivoSeleccionado(file);
            if (onFileChange) onFileChange({ target: { files: [file] } }); // Simula el evento
        }
    };

    const handleClickUpload = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setArchivoSeleccionado(file);
            if (onFileChange) onFileChange(e);
        }
    };

    const handleCloseModal = () => {
        setTab('general'); // Resetea la pestaña
        setEditMode(false); // Resetea el modo de edición
        onClose();         // Llama al cierre original
    };

    // Efecto para manejar el escape key y cerrar popups del sidebar cuando se abre el modal
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                handleCloseModal();
            }
        };

        const handleClickOutside = (event) => {
            // Si el click es fuera del modal pero dentro del overlay, cerrar el modal
            if (event.target.classList.contains('modal-overlay')) {
                handleCloseModal();
            }
        };

        // Función para detectar cambios en el sidebar
        const detectSidebarState = () => {
            const sidebar = document.querySelector('.sidebar');
            if (sidebar) {
                const isCollapsed = sidebar.classList.contains('collapsed');
                document.body.classList.toggle('sidebar-collapsed', isCollapsed);
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            document.addEventListener('click', handleClickOutside);

            // Agregar clase al body para prevenir scroll
            document.body.style.overflow = 'hidden';

            // Detectar estado inicial del sidebar
            detectSidebarState();

            // Observar cambios en el sidebar
            const sidebar = document.querySelector('.sidebar');
            if (sidebar) {
                const observer = new MutationObserver(detectSidebarState);
                observer.observe(sidebar, {
                    attributes: true,
                    attributeFilter: ['class']
                });

                return () => {
                    document.removeEventListener('keydown', handleKeyDown);
                    document.removeEventListener('click', handleClickOutside);
                    document.body.style.overflow = 'unset';
                    document.body.classList.remove('sidebar-collapsed');
                    observer.disconnect();
                };
            }

            return () => {
                document.removeEventListener('keydown', handleKeyDown);
                document.removeEventListener('click', handleClickOutside);
                document.body.style.overflow = 'unset';
                document.body.classList.remove('sidebar-collapsed');
            };
        }
    }, [isOpen]);


    useEffect(() => {
        if (trabajador && trabajador.Nombres) {
            CargaDatosIniciales();
        }
    }, [trabajador]);

    if (!isOpen || !trabajador) return null;

    const renderContent = () => {
        switch (tab) {
            case 'general':
                return (
                    <>
                        <div className="form-section">
                            {/* <div className="form-row">
                                <div>
                                    <label>Estado:</label>
                                    <input type="checkbox" checked readOnly />
                                </div>
                            </div> */}
                            <div className="form-row">
                                <div class="input-wrapper">
                                    <input type="text" id="Nombres" value={nombres} onChange={(event) => { setNombres(event.target.value); }} readOnly={!editMode} />
                                    <label for="cargo">Nombres</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="text" id="Apellidos" value={apellidos} onChange={(event) => { setApellidos(event.target.value); }} readOnly={!editMode} />
                                    <label for="cargo">Apellidos</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="text" id="Rut" value={formatRutDV(rut)} readOnly />
                                    <label for="cargo">Rut</label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div class="input-wrapper">
                                    <input type="text" id="Nacionalidad" value={nacionalidad} onChange={(event) => { setNacionalidad(event.target.value); }} readOnly={!editMode} />
                                    <label for="cargo">Nacionalidad</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="text" id="fNacimiento" value={fechaNacimiento} onChange={(event) => { setFechaNacimiento(event.target.value); }} readOnly={!editMode} />
                                    <label for="cargo">Fecha nacimiento</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="text" id="eCivil" value={estadoCivil} onChange={(event) => { setEstadoCivil(event.target.value); }} readOnly={!editMode} />
                                    <label for="cargo">Estado civil</label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div class="input-wrapper select-wrapper">
                                    <select id="afp" disabled={!editMode} value={afp} onChange={(event) => setAfp(event.target.value)}>
                                        <option value="none" disabled selected hidden >Seleccione:</option>
                                        <option value="AFP Capital">AFP Capital</option>
                                        <option value="AFP Cuprum">AFP Cuprum</option>
                                        <option value="AFP Habitat">AFP Habitat</option>
                                        <option value="AFP Modelo">AFP Modelo</option>
                                        <option value="AFP PlanVital">AFP PlanVital</option>
                                        <option value="AFP Provida">AFP Provida</option>
                                        <option value="AFP Uno">AFP Uno</option>
                                    </select>
                                    <label for="afp">AFP</label>
                                </div>
                                <div class="input-wrapper">
                                    <select id="Prevision" disabled={!editMode} value={prevision} onChange={(event) => setPrevision(event.target.value)}>
                                        <option value="none" disabled selected hidden >Seleccione:</option>
                                        <option value="Fonasa">Fonasa</option>
                                        <option value="Isapre Nueva Masvida">Isapre Nueva Masvida</option>
                                        <option value="Isapre Codelco Ltda">Isapre Codelco Ltda</option>
                                        <option value="Isapre Cruz del norte">Isapre Cruz del norte</option>
                                        <option value="Isapre Cruz Blanca S.A.">Isapre Cruz Blanca S.A.</option>
                                        <option value="Isapre Banmedica">Isapre Banmedica</option>
                                        <option value="Isapre VidaTres">Isapre VidaTres</option>
                                        <option value="Isapre Colmena">Isapre Colmena</option>
                                        <option value="Isapre Colmena">Isapre Consalud</option>
                                    </select>
                                    <label for="cargo">Cargo</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="text" id="Domicilio" readOnly={!editMode} value={domicilio} onChange={(event) => setDomicilio(event.target.value)} />
                                    <label for="cargo">Domicilio</label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div class="input-wrapper">
                                    <input type="text" id="Comuna" readOnly={!editMode} value={comuna} onChange={(event) => setComuna(event.target.value)} />
                                    <label for="cargo">Comuna</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="text" id="cargo" readOnly={!editMode} value={cargo} onChange={(event) => setCargo(event.target.value)} />
                                    <label for="cargo">Cargo</label>
                                </div>
                                <div class="input-wrapper select-wrapper">
                                    <select id="tContrato" disabled={!editMode} value={tipoContrato} onChange={(event) => setTipoContrato(event.target.value)}>
                                        <option value="none" disabled selected hidden>Seleccione:</option>
                                        <option value="Plazo fijo">Plazo fijo</option>
                                        <option value="Indefinido">Indefinido</option>
                                    </select>
                                    <label for="afp">Tipo Contrato</label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div class="input-wrapper">
                                    <input type="date" id="cDesde" readOnly={!editMode} value={vigenciaDesde} onChange={(event) => setVigenciaDesde(event.target.value)} />
                                    <label for="cargo">Desde</label>
                                </div>
                                <div class="input-wrapper">
                                    <input type="date" id="cHasta" readOnly={!editMode} value={vigenciaHasta} onChange={(event) => setVigenciaHasta(event.target.value)} />
                                    <label for="cargo">Hasta</label>
                                </div>
                            </div>
                        </div>
                    </>
                );
            case 'uploads':
                return (
                    <>
                        <div className="form-section">
                            <div className="form-row">
                                <div class="input-wrapper select-wrapper">
                                    <select id="tArchivo" onChange={(event) => {
                                        const value = event.target.value;
                                        setTipoArchivo(value === "Otros" ? "Otros:" : value);
                                    }}>
                                        <option value="none">Seleccione:</option>
                                        <option value="Contrato">Contrato</option>
                                        <option value="Anexos">Anexos</option>
                                        <option value="Liquidaciones">Liquidaciones</option>
                                        <option value="Compensados">Compensados</option>
                                        <option value="Permisos">Permisos</option>
                                        <option value="Vacaciones">Vacaciones</option>
                                        <option value="Finiquito">Finiquito</option>
                                        <option value="Termino de contrato">Termino de contrato</option>
                                        <option value="asignaciones">Asignación EPP</option>x
                                        <option value="Liquidaciones">Liquidaciones</option>
                                        <option value="Otros">Otros</option>
                                    </select>
                                    <label for="tArchivox">Tipo archivo</label>
                                    <br></br>
                                    {TipoArchivo.startsWith("Otros:") && (
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Especifique tipo de archivo"
                                            value={TipoArchivo.replace("Otros:", "")} // Muestra solo el contenido manual
                                            onChange={(event) => setTipoArchivo(`Otros:${event.target.value}`)} // Actualiza el texto manualmente
                                        />
                                    )}
                                </div>
                            </div>
                            <div
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onClick={handleClickUpload}
                                className={`drop-zone ${dragOver ? "drag-over" : ""}`}
                                style={{
                                    border: '2px dashed #ccc',
                                    padding: '30px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    backgroundColor: dragOver ? '#e9f5ff' : '#fff',
                                }}
                            >
                                <p>Arrastra el archivo aquí o haz clic para seleccionar</p>
                                <input
                                    type="file"
                                    ref={inputRef}
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />
                            </div>

                            {archivoSeleccionado && (
                                <p className="mt-2">Archivo seleccionado: <strong>{archivoSeleccionado.name}</strong></p>
                            )}

                            <button className="btn btn-success mt-3" onClick={onFileUpload}>Subir</button>
                        </div>
                    </>
                );

            case 'contratos':
            case 'liquidaciones':
            case 'certificados':
            case 'permisos':
            case 'vacaciones':
            case 'compensados':
            case 'asignaciones':
            case 'otros':
                return (
                    <>
                        {/* Puedes mostrar algún texto u otro elemento según la pestaña si quieres */}
                        {renderTablaArchivos()}
                    </>
                );
            default:
                return <p>Selecciona una pestaña.</p>;
        }
    };
    return (
        <div className="modal-overlay">
            <div className="modal-container modal-large">
                <p>Información del empleado</p>
                <button className="close-button" onClick={handleCloseModal}>x</button>
                <div className="modal-layout">
                    {/* Panel izquierdo con foto y datos del trabajador */}
                    <div className="modal-sidebar">
                        <div className="photo-placeholder" />
                        <img
                            src="/img/perfilH.svg"
                            alt="Foto del trabajador"
                            className="photo-img"
                        />
                        <h2>{trabajador.Nombres} {trabajador.Apellidos}</h2>
                        <div className="info-box">
                            <p><strong>RUT:</strong>{formatRutDV(trabajador.Rut)}</p>
                            <p><strong>Fecha ingreso:</strong>{trabajador.VigenciaDesde}</p>
                            <p><strong>Estado</strong>{trabajador.Estado}</p>
                        </div>
                    </div>

                    {/* Panel derecho con pestañas en el banner superior y contenido */}
                    <div className="modal-main-content">
                        <div className="menu-tabs">
                            <button className={`tab-button ${tab === 'general' ? 'active' : ''}`} onClick={() => setTab('general')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaAddressCard size={20} />
                                    <span>Información General</span>
                                </div>
                            </button>
                            <button className={tab === 'contratos' ? 'active' : ''} onClick={() => handleTabChange('contratos')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaFileContract size={16} />
                                    Contratos y anexos
                                </div>
                            </button>
                            <button className={tab === 'compensados' ? 'active' : ''} onClick={() => handleTabChange('compensados')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaFileInvoice size={16} />
                                    Compensados
                                </div>
                            </button>
                            <button className={tab === 'permisos' ? 'active' : ''} onClick={() => handleTabChange('permisos')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaFileInvoice size={16} />
                                    Permisos
                                </div>
                            </button>
                            <button className={tab === 'vacaciones' ? 'active' : ''} onClick={() => handleTabChange('vacaciones')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaFileImport size={16} />
                                    Vacaciones
                                </div>
                            </button>
                            <button className={tab === 'liquidaciones' ? 'active' : ''} onClick={() => handleTabChange('liquidaciones')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaFileInvoiceDollar size={16} />
                                    Liquidaciones
                                </div>
                            </button>
                            <button className={tab === 'asignaciones' ? 'active' : ''} onClick={() => handleTabChange('asignaciones')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaHardHat size={16} />
                                    Asignaciones
                                </div>
                            </button>
                            <button className={tab === 'otros' ? 'active' : ''} onClick={() => handleTabChange('otros')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaHardHat size={16} />
                                    Otros
                                </div>
                            </button>
                            <button className={tab === 'uploads' ? 'active' : ''} onClick={() => setTab('uploads')}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <FaUpload size={16} />
                                    Subir archivo
                                </div>
                            </button>
                            {/* Agrega más botones aquí */}
                        </div>

                        {/* Contenido de las pestañas */}
                        {renderContent()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TrabajadorModal